// extracted by mini-css-extract-plugin
export default {"menu":"MainMenu_menu__a0GJv"};